<p>process-recurrences works!</p>
